// extracted by mini-css-extract-plugin
module.exports = {"header":"CancelMembershipModal_header__1sKLe","buttonYes":"CancelMembershipModal_buttonYes__1ZK_2","errorMessage":"CancelMembershipModal_errorMessage__2ubrO"};